import axios from '../axios';
import util from './util';
const apiPath = 'api/admin/crowdfunds';

const crowdfundApi = {
    index: query => {
        return axios.get(
            `${
                process.env.VUE_APP_API_ENDPOINT
            }/${apiPath}/index?${util.queryToString(query)}`
        );
    },
    show: id => {
        return axios.get(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/show/${id}`
        );
    },
    update: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/update/${id}`,
            {
                ...entity
            }
        );
    },
    deny: id => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/deny`
        );
    },
    approve: id => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/approve`
        );
    },
    delete: id => {
        return axios.delete(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/delete/${id}`
        );
    },
    startCrowdfunding: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/start-crowdfund`,
            {
                ...entity
            }
        );
    },
    lockdown: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/lockdown`,
            {
                ...entity
            }
        );
    },
    markAsSuccess: id => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/mark-as-success`
        );
    },
    finish: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/finish`,
            {
                ...entity
            }
        );
    },
    forceConfirm: id => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/force-confirm`,
            {
                status_code: '200',
                status_message: 'Force Confirm by Admin',
                payment_type: 'admin_force_confirm',
                transaction_status: 'capture',
                fraud_status: 'accept'
            }
        );
    },
    create: entity => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/create`,
            {
                ...entity
            }
        );
    },
    advertiseWithProperty: (id, entity) => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/advertise/${id}/property`,
            {
                ...entity
            }
        );
    },
    advertiseWithProject: (id, entity) => {
        return axios.post(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/advertise/${id}/project`,
            {
                ...entity
            }
        );
    },
    reCrowdfund: (id, entity) => {
        return axios.put(
            `${process.env.VUE_APP_API_ENDPOINT}/${apiPath}/${id}/re-crowdfund`,
            {
                ...entity
            }
        );
    }
};

export default crowdfundApi;
